// @ts-ignore
export const DEV: any = typeof __DEV__ !== 'undefined' && __DEV__;

export const LOCAL_PRODUCTION_BACKEND: any =
	// @ts-ignore
	typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' &&
	// @ts-ignore
	__LOCAL_PRODUCTION_BACKEND__;
